<template>
	<div>
		<h2 class="titleFont p-pl-2 p-text-bold">Step 1: Cookie Orders</h2>

		<div>
			<h4
				class="p-d-flex p-flex-column p-flex-sm-row p-justify-center p-align-center"
			>
				<p class="p-pr-2">Number of Delivery Locations (Max 10):</p>
				<p class="p-grid p-col-4 p-sm-2">
					<InputNumber
						v-model="numberOfLocations"
						:min="1"
						:max="10"
						showButtons
					/>
				</p>
			</h4>
		</div>

		<!-- :numberOfLocations="numberOfLocations" -->
		<div v-for="locationNumber in numberOfLocations" :key="locationNumber">
			<DeliveryLocationDetailsCard
				:locationNumber="locationNumber"
				:validateForm="validateForm"
				:validateAllLocationForms="validateAllLocationForms"
				@locationTotalAmount="getLocationTotalAmount"
			/>
		</div>

		<div
			v-if="totalAmountAllLocations != 0"
			class="totalAmountAllLocations p-text-center p-text-md-right"
		>
			<h3>Total Amount: ${{ totalAmountAllLocations.toFixed(2) }} CAD</h3>
		</div>

		<div class="p-fluid p-grid p-formgrid p-d-flex p-flex-column p-ai-center">
			<div
				class="p-d-flex p-flex-column p-flex-sm-row p-justify-center p-align-center p-mt-2"
			>
				<label class="p-pr-2 p-text-bold p-mb-2 p-mb-md-0"
					>Select the date of Delivery</label
				>
				<div>
					<Dropdown
						id="deliveryDate"
						v-model="selectedDeliveryDate"
						:options="deliveryDateOptions"
						optionLabel="name"
						placeholder="Select a Date"
						style="min-width: 190px"
					/>

					<small
						v-if="v$.selectedDeliveryDate.$invalid && submitted"
						class="p-error p-text-bold"
					>
						{{
							v$.selectedDeliveryDate.required.$message.replace(
								"Value",
								"Delivery Date"
							)
						}}
					</small>
				</div>
			</div>
			<p class="p-text-bold p-my-2">
				Orders MUST be submitted two days before selected delivery date.
			</p>
		</div>

		<div class="p-d-flex p-jc-center p-mt-4">
			<Button
				label="Next"
				icon="pi pi-angle-right"
				iconPos="right"
				style="min-width: 120px; max-width: 120px"
				@click="nextStep()"
			/>
		</div>
	</div>
</template>

<script>
import { useFormDataStore } from "../../store/formData.js";
import DeliveryLocationDetailsCard from "../DeliveryLocationDetailsCard.vue";
import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default {
	name: "S1Form",
	components: {
		DeliveryLocationDetailsCard,
	},
	data() {
		return {
			numberOfLocations: 1,
			validateForm: 0,
			totalAmountAllLocations: 0,
			deliveryDateOptions: [
				{ name: "28th April, 2025", code: "apr28" },
				{ name: "29th April, 2025", code: "apr29" },
				{ name: "30th April, 2025", code: "apr30" },
				{ name: "1st May, 2025", code: "may1" },
				{ name: "2nd May, 2025", code: "may2" },
			],
			selectedDeliveryDate: null,
			isS1FormValid: false,
			submitted: false,
			allLocationFormStates: [{}],
			locationTotalAmountArray: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
		};
	},
	setup() {
		const store = useFormDataStore();

		return {
			store,
			v$: useVuelidate(),
		};
	},
	validations() {
		return {
			selectedDeliveryDate: { required },
		};
	},
	props: {
		loadDonationParams: {
			type: Object,
		},
	},
	watch: {
		numberOfLocations() {
			this.totalAmountAllLocations = 0;

			for (let i = 1; i <= this.numberOfLocations; i++) {
				this.totalAmountAllLocations += this.locationTotalAmountArray[i];
			}

			if (
				this.store.S1LocationsInfoData["student" + (this.numberOfLocations + 1)]
			) {
				delete this.store.S1LocationsInfoData[
					"student" + (this.numberOfLocations + 1)
				];
			}
		},
	},
	methods: {
		nextStep() {
			this.validateForm += 1;

			for (let i = 1; i <= this.numberOfLocations; i++) {
				this.allLocationFormStates[i] = false;
			}

			this.submitted = true;
		},
		validateAllLocationForms(validLocationInfoForm, locationNumber) {
			this.allLocationFormStates[locationNumber] = validLocationInfoForm;
			let validStates = Object.values(this.allLocationFormStates);
			let allFormsValid = true;
			for (let i = 1; i <= this.numberOfLocations; i++) {
				if (validStates[i] === false) {
					allFormsValid = false;
				}
			}

			if (allFormsValid && !this.v$.selectedDeliveryDate.$invalid) {
				this.store.setS1FormData({
					totalAmountAllLocations: this.totalAmountAllLocations,
					deliveryDate: this.selectedDeliveryDate,
				});
				this.$emit("nextStep");
			} else {
				this.scrollToFirstError();
			}
		},
		getLocationTotalAmount(locationTotalAmount, locationNumber) {
			// TODO: could save the data for validation in the same array too
			this.locationTotalAmountArray[locationNumber] = locationTotalAmount;
			this.totalAmountAllLocations = 0;

			for (let i = 1; i <= this.numberOfLocations; i++) {
				this.totalAmountAllLocations += this.locationTotalAmountArray[i];
			}
		},
		scrollToFirstError() {
			this.$nextTick(() => {
				if (document.querySelector(".p-error")) {
					let domRect = document
						.querySelector(".p-error")
						.getBoundingClientRect();

					window.scrollTo({
						left: domRect.left + document.documentElement.scrollLeft,
						top: domRect.top + document.documentElement.scrollTop - 100,
						behavior: "smooth",
					});
				}
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.activeCard {
	border: 5px solid $primary-color;
}

.totalAmountAllLocations {
	h3 {
		font-size: 1.5rem;
	}
}

.titleFont {
	font-size: 1.9rem;
}
</style>
